// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MonthlyDeals: React.FC = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 55 62" enableBackground="new 0 0 55 62" xmlSpace="preserve">
   <path id="tab_1_" fillRule="evenodd" clipRule="evenodd" fill="#DF564B" d="M55,0H40.27H14.74H0v47.23
       c0,8.14,6.6,14.74,14.74,14.74h25.53c8.14,0,14.73-6.6,14.73-14.74"/>
   <g id="shadow">
       <path fillRule="evenodd" clipRule="evenodd" fill="#932A25" d="M55,47.23V27.05L42.23,14.06c-0.25-0.66-0.89-1.12-1.63-1.12
           H30.08c-0.49,0-0.93,0.2-1.25,0.53L14.82,27.47c-0.34,0.34-0.51,0.79-0.51,1.24c0,0.44,0.17,0.9,0.51,1.24l30.56,31.08
           C50.99,58.95,55,53.56,55,47.23z"/>
   </g>
   <defs>
       <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="13.31" y="11.94" width="28.04" height="28.05">
           <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
       </filter>
   </defs>
   <path id="tag" fillRule="evenodd" clipRule="evenodd" fill="#FEFEFE" d="M36.97,18.07
       c0.97,0,1.75-0.78,1.75-1.75c0-0.97-0.78-1.75-1.75-1.75c-0.97,0-1.75,0.78-1.75,1.75C35.22,17.29,36,18.07,36.97,18.07
        M41.35,13.69v10.52c0,0.45-0.17,0.9-0.51,1.24L26.82,39.47c-0.34,0.34-0.79,0.51-1.24,0.51c-0.44,0-0.9-0.17-1.24-0.51L13.82,28.95
       c-0.34-0.34-0.51-0.8-0.51-1.24c0-0.45,0.17-0.9,0.51-1.24l14.01-14.01c0.32-0.32,0.76-0.53,1.25-0.53H39.6
       C40.57,11.94,41.35,12.72,41.35,13.69"/>
   </svg>     
    );
};


export default React.memo(MonthlyDeals);


